.familyFlowContent :global(.mantine-datatable-header-cell-sortable-group) {
  flex-direction: row-reverse;
  gap: 4px;
}
